import DecisionNodeBase from '~/models/journey/DecisionNodeBase'
import type { WaypointNode } from '~/models/journey/waypoints'
import type { Path } from '~/types/util'
import { SessionStore } from '~/stores/session'
import { PlanType, WaypointResult } from '~/generated/api-clients-generated'

export class IsMapdAvailableNode extends DecisionNodeBase {
  getNext(): WaypointNode | Path | null {
    const session = SessionStore.use()

    const result = session.availablePlanTypes.includes(PlanType.MAPD)
      ? WaypointResult.MapdAvailable
      : WaypointResult.MapdUnavailable

    return this._destinations.get(result) ?? null
  }
}
